"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MessageTemplateData = void 0;
const with_class_name_1 = require("./with-class-name");
class MessageTemplateData extends with_class_name_1.WithClassName {
    constructor() {
        super(...arguments);
        this.templateName = '';
        this.templateVariables = [];
    }
}
exports.MessageTemplateData = MessageTemplateData;



//////////////////
// WEBPACK FOOTER
// ./~/rules-config/lib/message-template-data.js
// module id = 1220
// module chunks = 0